var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftLg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0075 21C14.745 21.0022 14.492 20.9013 14.3032 20.7189L6.29337 12.708C6.20061 12.6147 6.12712 12.5042 6.0771 12.3825C6.02621 12.2614 6 12.1314 6 12C6 11.8686 6.02621 11.7386 6.0771 11.6175C6.12712 11.4958 6.20061 11.3853 6.29337 11.292L14.3032 3.2811C14.492 3.09869 14.745 2.99776 15.0075 3.00004C15.27 3.00232 15.5211 3.10763 15.7067 3.29329C15.8924 3.47896 15.9977 3.73011 16 3.99267C16.0022 4.25522 15.9013 4.50817 15.7189 4.69703L8.41697 12L9.4182 13.0014L15.7189 19.303C15.9013 19.4918 16.0022 19.7448 16 20.0073C15.9977 20.2699 15.8924 20.521 15.7067 20.7067C15.5211 20.8924 15.27 20.9977 15.0075 21Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftLg);
export default __webpack_public_path__ + "static/media/left-lg.9e06638c9bcfb3942fbd570caca0af5c.svg";
export { ForwardRef as ReactComponent };